import { getStateColors } from './icon_helpers';

/**
 * Creates a resources infrastructure - electricity isolation point icon
 * @param {string|null} state - Asset state ('available', 'locked_out', etc.)
 * @returns {string} Data URL containing SVG icon
 */
export const createElectricityIsolationPointIcon = (state = null) => {
  const colors = getStateColors(state);

  const svgContent = `
    <svg width="226" height="336" viewBox="0 0 226 336" xmlns="http://www.w3.org/2000/svg">
      <!-- Pin base -->
      <path d="M203 123.75 C203 80.565 168.435 45 123.75 45 S44.5 80.565 44.5 123.75 c0 43.185 79.25 173.25 79.25 173.25 s79.25-130.065 79.25-173.25 z" fill="${colors.pinColor}"/>

      <!-- Icon background circle -->
      <circle cx="123.75" cy="123.75" r="52.47" fill="${colors.ringColor}" stroke="${colors.ringColor}" stroke-width="12.6"/>
      <circle cx="123.75" cy="123.75" r="37.8" fill="white"/>

      <!-- resources infrastructure - electricity isolation point icon (scaled and centered) -->
      <g transform="translate(123.75, 123.75) scale(3.2) translate(-21, -21)">
        <g  transform="translate(9 9)">
<rect fill="${colors.iconColor}" x="6" y="4" width="12" height="16" rx="1" /><path fill="${colors.iconColor}" d="M13 8l-3 5h2l-2 5 4-6h-2l3-4z" /><circle fill="${colors.iconColor}" cx="9" cy="18" r="1" /><circle fill="${colors.iconColor}" cx="15" cy="18" r="1" /><rect fill="${colors.iconColor}" x="10" y="2" width="4" height="2" />
    </g>
      </g>
    </svg>
  `;

  return 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svgContent);
};

/**
 * Creates a resources infrastructure - emergency contact board icon
 * @param {string|null} state - Asset state ('available', 'locked_out', etc.)
 * @returns {string} Data URL containing SVG icon
 */
export const createEmergencyContactBoardIcon = (state = null) => {
  const colors = getStateColors(state);

  const svgContent = `
    <svg width="226" height="336" viewBox="0 0 226 336" xmlns="http://www.w3.org/2000/svg">
      <!-- Pin base -->
      <path d="M203 123.75 C203 80.565 168.435 45 123.75 45 S44.5 80.565 44.5 123.75 c0 43.185 79.25 173.25 79.25 173.25 s79.25-130.065 79.25-173.25 z" fill="${colors.pinColor}"/>

      <!-- Icon background circle -->
      <circle cx="123.75" cy="123.75" r="52.47" fill="${colors.ringColor}" stroke="${colors.ringColor}" stroke-width="12.6"/>
      <circle cx="123.75" cy="123.75" r="37.8" fill="white"/>

      <!-- resources infrastructure - emergency contact board icon (scaled and centered) -->
      <g transform="translate(123.75, 123.75) scale(3.2) translate(-21, -21)">
        <g  transform="translate(9 9)">
<rect fill="${colors.iconColor}" x="4" y="3" width="16" height="13" rx="1" /><rect fill="${colors.iconColor}" x="6" y="6" width="12" height="1.5" /><rect fill="${colors.iconColor}" x="6" y="9" width="12" height="1.5" /><rect fill="${colors.iconColor}" x="6" y="12" width="7" height="1.5" /><path fill="${colors.iconColor}" d="M15 11l2 2 2.5-2.5" /><rect fill="${colors.iconColor}" x="11.5" y="16" width="1.5" height="6" /><rect fill="${colors.iconColor}" x="8" y="21" width="8" height="1.5" />
    </g>
      </g>
    </svg>
  `;

  return 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svgContent);
};

/**
 * Creates a resources infrastructure - emergency response plans icon
 * @param {string|null} state - Asset state ('available', 'locked_out', etc.)
 * @returns {string} Data URL containing SVG icon
 */
export const createEmergencyResponsePlansIcon = (state = null) => {
  const colors = getStateColors(state);

  const svgContent = `
    <svg width="226" height="336" viewBox="0 0 226 336" xmlns="http://www.w3.org/2000/svg">
      <!-- Pin base -->
      <path d="M203 123.75 C203 80.565 168.435 45 123.75 45 S44.5 80.565 44.5 123.75 c0 43.185 79.25 173.25 79.25 173.25 s79.25-130.065 79.25-173.25 z" fill="${colors.pinColor}"/>

      <!-- Icon background circle -->
      <circle cx="123.75" cy="123.75" r="52.47" fill="${colors.ringColor}" stroke="${colors.ringColor}" stroke-width="12.6"/>
      <circle cx="123.75" cy="123.75" r="37.8" fill="white"/>

      <!-- resources infrastructure - emergency response plans icon (scaled and centered) -->
      <g transform="translate(123.75, 123.75) scale(3.2) translate(-21, -21)">
        <g  transform="translate(9 9)">
<rect fill="${colors.iconColor}" x="5" y="2" width="14" height="20" rx="1" /><rect fill="${colors.iconColor}" x="8" y="5" width="8" height="1.5" /><rect fill="${colors.iconColor}" x="8" y="8" width="8" height="1.5" /><path fill="${colors.iconColor}" d="M12 11l-3 3h2v3h2v-3h2z" /><circle fill="${colors.iconColor}" cx="9" cy="18" r="1" /><circle fill="${colors.iconColor}" cx="12" cy="18" r="1" /><circle fill="${colors.iconColor}" cx="15" cy="18" r="1" />
    </g>
      </g>
    </svg>
  `;

  return 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svgContent);
};

/**
 * Creates a resources infrastructure - fuel access icon
 * @param {string|null} state - Asset state ('available', 'locked_out', etc.)
 * @returns {string} Data URL containing SVG icon
 */
export const createFuelAccessIcon = (state = null) => {
  const colors = getStateColors(state);

  const svgContent = `
    <svg width="226" height="336" viewBox="0 0 226 336" xmlns="http://www.w3.org/2000/svg">
      <!-- Pin base -->
      <path d="M203 123.75 C203 80.565 168.435 45 123.75 45 S44.5 80.565 44.5 123.75 c0 43.185 79.25 173.25 79.25 173.25 s79.25-130.065 79.25-173.25 z" fill="${colors.pinColor}"/>

      <!-- Icon background circle -->
      <circle cx="123.75" cy="123.75" r="52.47" fill="${colors.ringColor}" stroke="${colors.ringColor}" stroke-width="12.6"/>
      <circle cx="123.75" cy="123.75" r="37.8" fill="white"/>

      <!-- resources infrastructure - fuel access icon (scaled and centered) -->
      <g transform="translate(123.75, 123.75) scale(3.2) translate(-21, -21)">
        <g  transform="translate(9 9)">
<rect fill="${colors.iconColor}" x="6" y="6" width="8" height="14" rx="1" /><rect fill="none" stroke="${colors.iconColor}" stroke-width="2" x="8" y="9" width="4" height="4" /><rect fill="${colors.iconColor}" x="8" y="15" width="4" height="2" /><path fill="${colors.iconColor}" d="M14 11h2v2c0 1 .5 1.5 1 1.5s1-.5 1-1.5v-2c0-1-.5-2-1.5-2s-1.5 1-1.5 2" /><circle fill="${colors.iconColor}" cx="18.5" cy="10" r="1" /><rect fill="${colors.iconColor}" x="7" y="4" width="5" height="2" /><rect fill="${colors.iconColor}" x="5" y="20" width="10" height="1.5" />
    </g>
      </g>
    </svg>
  `;

  return 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svgContent);
};

/**
 * Creates a resources infrastructure - hydrants icon
 * @param {string|null} state - Asset state ('available', 'locked_out', etc.)
 * @returns {string} Data URL containing SVG icon
 */
export const createHydrantsIcon = (state = null) => {
  const colors = getStateColors(state);

  const svgContent = `
    <svg width="226" height="336" viewBox="0 0 226 336" xmlns="http://www.w3.org/2000/svg">
      <!-- Pin base -->
      <path d="M203 123.75 C203 80.565 168.435 45 123.75 45 S44.5 80.565 44.5 123.75 c0 43.185 79.25 173.25 79.25 173.25 s79.25-130.065 79.25-173.25 z" fill="${colors.pinColor}"/>

      <!-- Icon background circle -->
      <circle cx="123.75" cy="123.75" r="52.47" fill="${colors.ringColor}" stroke="${colors.ringColor}" stroke-width="12.6"/>
      <circle cx="123.75" cy="123.75" r="37.8" fill="white"/>

      <!-- resources infrastructure - hydrants icon (scaled and centered) -->
      <g transform="translate(123.75, 123.75) scale(3.2) translate(-21, -21)">
        <g  transform="translate(9 9)">
<rect fill="${colors.iconColor}" x="9" y="6" width="6" height="12" rx="1" /><circle fill="${colors.iconColor}" cx="12" cy="10" r="1.5" /><circle fill="${colors.iconColor}" cx="12" cy="14" r="1.5" /><rect fill="${colors.iconColor}" x="10" y="4" width="4" height="2" /><rect fill="${colors.iconColor}" x="10" y="18" width="4" height="2" /><rect fill="${colors.iconColor}" x="6" y="9" width="3" height="2" /><rect fill="${colors.iconColor}" x="15" y="9" width="3" height="2" /><rect fill="${colors.iconColor}" x="8" y="20" width="8" height="2" />
    </g>
      </g>
    </svg>
  `;

  return 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svgContent);
};

/**
 * Creates a resources infrastructure - signage general safety signs icon
 * @param {string|null} state - Asset state ('available', 'locked_out', etc.)
 * @returns {string} Data URL containing SVG icon
 */
export const createSignageGeneralSafetySignsIcon = (state = null) => {
  const colors = getStateColors(state);

  const svgContent = `
    <svg width="226" height="336" viewBox="0 0 226 336" xmlns="http://www.w3.org/2000/svg">
      <!-- Pin base -->
      <path d="M203 123.75 C203 80.565 168.435 45 123.75 45 S44.5 80.565 44.5 123.75 c0 43.185 79.25 173.25 79.25 173.25 s79.25-130.065 79.25-173.25 z" fill="${colors.pinColor}"/>

      <!-- Icon background circle -->
      <circle cx="123.75" cy="123.75" r="52.47" fill="${colors.ringColor}" stroke="${colors.ringColor}" stroke-width="12.6"/>
      <circle cx="123.75" cy="123.75" r="37.8" fill="white"/>

      <!-- resources infrastructure - signage general safety signs icon (scaled and centered) -->
      <g transform="translate(123.75, 123.75) scale(3.2) translate(-21, -21)">
        <g  transform="translate(9 9)">
<path fill="${colors.iconColor}" d="M12 2l7 4v5l-7 4-7-4V6z" /><rect fill="${colors.iconColor}" x="11" y="7" width="2" height="4" /><circle fill="${colors.iconColor}" cx="12" cy="13" r="1" /><rect fill="${colors.iconColor}" x="11.5" y="15" width="1.5" height="7" /><rect fill="${colors.iconColor}" x="8" y="21.5" width="8" height="1.5" />
    </g>
      </g>
    </svg>
  `;

  return 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svgContent);
};

/**
 * Creates a resources infrastructure - water access tank icon
 * @param {string|null} state - Asset state ('available', 'locked_out', etc.)
 * @returns {string} Data URL containing SVG icon
 */
export const createWaterAccessTankIcon = (state = null) => {
  const colors = getStateColors(state);

  const svgContent = `
    <svg width="226" height="336" viewBox="0 0 226 336" xmlns="http://www.w3.org/2000/svg">
      <!-- Pin base -->
      <path d="M203 123.75 C203 80.565 168.435 45 123.75 45 S44.5 80.565 44.5 123.75 c0 43.185 79.25 173.25 79.25 173.25 s79.25-130.065 79.25-173.25 z" fill="${colors.pinColor}"/>

      <!-- Icon background circle -->
      <circle cx="123.75" cy="123.75" r="52.47" fill="${colors.ringColor}" stroke="${colors.ringColor}" stroke-width="12.6"/>
      <circle cx="123.75" cy="123.75" r="37.8" fill="white"/>

      <!-- resources infrastructure - water access tank icon (scaled and centered) -->
      <g transform="translate(123.75, 123.75) scale(3.2) translate(-21, -21)">
        <g  transform="translate(9 9)">
<ellipse fill="${colors.iconColor}" cx="12" cy="7" rx="7" ry="2" /><path fill="${colors.iconColor}" d="M5 7v9c0 1.1 3.1 2 7 2s7-.9 7-2V7" /><path fill="${colors.iconColor}" d="M5 11c0 1.1 3.1 2 7 2s7-.9 7-2" /><rect fill="${colors.iconColor}" x="8" y="18" width="1.5" height="4" /><rect fill="${colors.iconColor}" x="11.25" y="18" width="1.5" height="4" /><rect fill="${colors.iconColor}" x="14.5" y="18" width="1.5" height="4" />
    </g>
      </g>
    </svg>
  `;

  return 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svgContent);
};

export const resourcesinfrastructureIcons = {
  electricity_isolation_point: createElectricityIsolationPointIcon,
  emergency_contact_board: createEmergencyContactBoardIcon,
  emergency_response_plans: createEmergencyResponsePlansIcon,
  fuel_access: createFuelAccessIcon,
  hydrants: createHydrantsIcon,
  signage_general_safety_signs: createSignageGeneralSafetySignsIcon,
  water_access_tank: createWaterAccessTankIcon
};
